<template>
  <div class="agents-select">
    <label
      v-for="(agent, index) in options"
      :key="index"
      :class="['responsible-agent-item', { 'responsible-agent-item--selected': isSelected(agent) }]"
      :role="multiple ? 'checkbox' : 'radio'"
      :aria-checked="isSelected(agent)"
    >
      <input
        v-if="multiple"
        v-model="selectedAgents"
        :value="agent.id"
        class="responsible-agent-item__selector"
        type="checkbox"
      />
      <input v-else v-model="selectedAgent" :value="agent.id" class="responsible-agent-item__selector" type="radio" />
      <div class="responsible-agent-item__agent">
        <div class="responsible-agent-item__agent-photo">
          <v-avatar :src="agent.photo" />
        </div>
        <div class="responsible-agent-item__agent-name">{{ agent.name }}</div>
      </div>
    </label>
  </div>
</template>

<script>
import VAvatar from '@/components/common/VAvatar.vue'

export default {
  name: 'AgentsSelect',
  components: { VAvatar },
  props: {
    value: {
      type: [Array, Object],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedAgent: {
      get() {
        return this.value?.id ?? null
      },
      set(agentId) {
        this.$emit(
          'input',
          this.options.find(option => option.id === agentId)
        )
      }
    },
    selectedAgents: {
      get() {
        return this.value.map(agent => agent.id)
      },
      set(agentsIds) {
        this.$emit(
          'input',
          this.options.filter(option => agentsIds.includes(option.id))
        )
      }
    }
  },
  methods: {
    isSelected({ id }) {
      return this.multiple ? this.selectedAgents.includes(id) : this.selectedAgent === id
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/media';

.responsible-agent-item {
  cursor: pointer;
  $this: &;

  padding: 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $--semi-light-gray;

  &--selected {
    background-color: $--darken-black-2percent;

    #{$this}__selector {
      border-color: $--pitch-black;
      background-image: url(../../assets/icons/i_tick.svg);
      background-position: 2px 2px;
      background-repeat: no-repeat;
    }
  }

  @include phone {
    padding: 16px 24px;
  }

  &__selector {
    appearance: none;
    margin-right: 22px;
    width: 20px;
    height: 20px;
    border: 1px solid $--darken-black-20percent;
    border-radius: 50%;

    @include phone {
      margin-left: auto;
      margin-right: 0;
      order: 2;
    }
  }

  &__agent {
    display: flex;
    align-items: center;
  }

  &__agent-photo {
    margin-right: 16px;
  }

  &__agent-name {
    font-size: $--font-size-medium;
  }
}
</style>
